// import React from "react";
import { useState, useEffect } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import authAxios from "../../components/authAxios"


import Pagination from '@mui/material/Pagination';

import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
// import DashboardHeader from "../../components/DashboardHeader";
import { useMediaQuery } from 'react-responsive'
// import { Card, CardContent } from "@mui/material";

import VisibilityOutlined from '@mui/icons-material/VisibilityOutlined';
import ArchiveSharpIcon from '@mui/icons-material/ArchiveSharp';  
import BackspaceIcon from '@mui/icons-material/Backspace';

import { Modal, message } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';

import moment from 'moment';


// import Layout from "../../components/Layout";
// import ThreeDotsMenu from "../../components/ThreeDotsMenu";
import EllipsisMenu from "../../components/EllipsisMenu";

import { format } from 'date-fns';
import MeterReadingNew from "./MeterReadingNew";
import Pillchip from "../../components/Pillchip";

import { extractErrorMessage } from "../../components/errorUtils";


// function MeterReadings({meter, meterReadings}) {
function MeterReadings({meter}) {
    const isMobile = useMediaQuery({ query: '(max-width: 750px)' })
    const [page, setPage] = useState(1);
    const [pagecount, setPageCount] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const queryClient = useQueryClient();

    const convertDateTime = (myDateTime) => {
        return format(new Date(myDateTime), 'dd-MM-yyyy HH:mm');
    };

    const { data: clientProfile } = useQuery({
        queryKey: ['clientProfile'],
        queryFn: async () => {
          const response = await authAxios.get(`/clientprofiles/${localStorage.getItem('clientProfile')}`);
          return response.data
        },
    });

    const { data: meterReadings, isLoading: meterReadingsLoading } = useQuery({
        queryKey: ['meterReadings', meter.id, page],
        queryFn: async () => {
          const response = await authAxios.get(`rentals/meter-readings/?meter=${meter.id}&page=${page}`);
          setPageCount(response.data.page_count);
          return response.data.results
        },
        enabled: !!meter
    });

    const [isDrawerOpen, setIsDrawerOpen] = useState(false)

    const handleDrawerOpen = () => {
        setIsDrawerOpen(true)
    };
  
    const handleDrawerClose = () => {
        setIsDrawerOpen(false)
    };

    //Pagination
    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const threeSubMenu = [
        {
            id: 1,
            menu: "View",
            url: "/dashboard/product/",
        }, 
        // {
        //     id: 2,
        //     menu: "Reverse",
        //     url: "/customeredit/",
        // }
    ];

    const menuItems = (reading) => {
        const baseItems = [
            {
                label: 'View',
                icon: <VisibilityOutlined />,
                onClick: () => {
                    // navigate(`/dashboard/payment/${payment.id}`)
                }
            },
        ];

        if (reading.status === '030' && reading.is_reversible === true) {
            baseItems.push({
                label: 'Reverse',
                icon: <BackspaceIcon />,
                onClick: () => {
                    showConfirm(reading.id)
                }
            });
        }

        return baseItems;

    };

    const formatNumber = (number) => {
        if (number === undefined || number === null) return '0.00';
        return number.toLocaleString(undefined, {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
        });
    }

    const reverseMutation = useMutation({
        mutationFn: (readingId) => {
            return authAxios.post(`/rentals/meter-readings/${readingId}/reverse/`);
        },
        onError: (error) => {
            const errorMessage = extractErrorMessage(error.response?.data) || error.message;
            message.error(errorMessage);
        },
        onSuccess: () => {
            message.success('Utility reading reversed successfully');
            queryClient.invalidateQueries(['meterReadings']);
        },
    });

    const { confirm } = Modal;
    const showConfirm = (readingId) => {
        confirm({
          title: 'Do you want to Reverse this Reading?',
          icon: <ExclamationCircleFilled />,
          onOk() {
            return reverseMutation.mutate(readingId);
          },
        });
    };


    return (
        <>          
        <table className="styled-table">
            <thead>
                <tr >
                    <th>Id</th>
                    <th>Date Posted</th>
                    <th>Reading Date</th>
                    <th className="cell-align-right">Current</th>
                    <th className="cell-align-right">Previous</th>
                    <th className="cell-align-right">Consumption</th>
                    <th className="cell-align-right">Bill</th>
                    <th>Status</th>
                    <th></th>
                </tr>
            </thead>

            {meterReadings && meterReadings.map(reading => (

                <tbody key={reading.id}>
                    <tr>
                        <td>{reading.id}</td>
                        <td>{convertDateTime(reading.created_at)}</td>
                        {/* <td>{convertDateTime(reading.date)}</td> */}
                        <td>{moment(reading.date).format('DD-MM-YYYY')}</td>
                        <td className="cell-align-right">{formatNumber(reading.current_reading)}</td>
                        <td className="cell-align-right">{formatNumber(reading.last_reading)}</td>
                        <td className="cell-align-right">{formatNumber(reading.consumption)}</td>
                        {clientProfile && clientProfile.currency_code? 
                            <td className="cell-align-right">{Number(reading.amount).toLocaleString('en-UK', { style: 'currency', currency: clientProfile.currency_code })}</td>
                            :
                            <td>{Number(reading.amount).toLocaleString('en-UK')}</td>
                        }
                        <td><Pillchip label={reading.status_name} /></td>
                        <td className='styled-table-menu'>
                            <EllipsisMenu items={menuItems(reading)} />
                        </td>
                    </tr>
                </tbody>
            ))}
        </table>

        <MeterReadingNew 
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            meter={meter}
        />
        
        <Pagination 
            className="custom-mui-pagination"
            count={pagecount} 
            page={page} 
            onChange={handlePageChange} 
        />

        {/* <Link to="/dashboard/product-new" className="nav-link">
            <Fab className="fab" color="primary" aria-label="add">
                <AddIcon />
            </Fab>
        </Link> */}
        <Fab className="fab" color="primary" aria-label="add" onClick={()=>{
            setIsModalOpen(true)}}
            >
            <AddIcon />
        </Fab>

    </>            

    )
}
export default MeterReadings